import { Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
// Added by Gauri to pass stage details on 29 Apr 2025
import { toast } from "react-toastify";
import axios from "axios";
import GetInitiativeStageDetails from "../../../hooks/GetInitiativeStageDetails/GetInitiativeStageDetails";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";

{/* Passed initiativesData and initiativesID by Gauri for Force push on 31 Mar 2025 */}
const WorkflowForcePush = ({data, data1, initiativesData, initiativesID, setOpen, onRefresh, handleGoBack, refreshKey}) => {
  console.log("WorkflowForcePush data:", data);
  console.log("WorkflowForcePush data1:", data1);
  console.log("WorkflowForcePush initiativesData:", initiativesData);

  {/* Added by Gauri for showing stage approvers details on 26 Mar 2025 */}
  const [stageDetails, setStageDetails] = useState(null);
  
  {/* Added by Gauri to get alertType for Force push on 31 Mar 2025 */}
  const selectedInitiative = initiativesData?.find(ini => ini.ideaIdPk === initiativesID) || {};
  const [iniAlertType, setIniAlertType] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  // console.log("initiativesData:", initiativesData);
  // console.log("initiativesID:", initiativesID);
  
  useEffect(() => {
    setIniAlertType(selectedInitiative.alertType);
  }, [selectedInitiative]);
  // console.log("selectedInitiative:", selectedInitiative);
  
  const handleModalClose = () => {
    setModalOpen(false); // Close the modal without deleting
  };
  // console.log("iniAlertType ID:", iniAlertType);
  console.log("iniAlertType ID:", data?.data?.listIniDetailsEntity?.[0]?.iniAlertType);
  
  // Added by Gauri to save force pushed initiative on 28 Apr 2025
  const handleConfirmPushBack = async () => {
    console.log("Initiatives ID:", initiativesID);

    try {
      // Prepare the request payload or query parameters
      const token = sessionStorage.getItem("access_token");
      const userdata = JSON.parse(sessionStorage.getItem("user"));
      const employeeId = userdata?.employeeId;

      if (!token) {
        toast.error("Authentication token is missing.");
        return;
      }

      const postUrl = `/api/ManageWorkFlow/PostForcePush?IdeaID=${initiativesID}&UserID=${employeeId}`;
      const response = await AxiosInstance1.post(`${postUrl}`, null, {
        // headers: {
        //   Authorization: `Bearer ${token}`
        // }
      });

      if (response.data) {
        toast.success("Initiative Force Pushed successfully");

        // Added by Gauri to send mail after save on 05 Mar 2025
        console.log("Force Push putResponse", response?.data?.data?.listWorkflowActionResponseEntity[0]);
        const emailData = response?.data?.data?.listWorkflowActionResponseEntity[0];
        // if (emailData?.result === "Success") {
        if (emailData?.message === "Success") {
          await sendForcePushEmail(emailData);
        }
        setModalOpen(false);
        setOpen(false);
        handleGoBack();

        // Fetch the updated list data
        // fetchIniStatusList(page, { ActionID: actionID });
      } else {
        toast.error("Failed to save Comment.");
      }
    } catch (error) {
      console.error("Error saving Comment:", error);
      toast.error("Error occurred while saving.");
    }
  };

  // Added by Gauri to send email for force pushed initiative on 28 Apr 2025
  const sendForcePushEmail = async (emailData) => {
    try {
      const emailUrl = `/api/EmailService/SendMail`;
      const params = {
        fromAddress: emailData.fromAddress,
        toAddress: emailData.toAddress,
        ccAddress: emailData.ccEmailAddress,
        subject: emailData.subject,
        body: emailData.body,
        isHtml: 1
      };
      console.log("Sending Email with params:", params);

      const token = sessionStorage.getItem("access_token");
      const response = await AxiosInstance1.post(emailUrl, params, {
        // headers: {
        //   Authorization: `Bearer ${sessionStorage.getItem("access_token")}`
        // }
      });

      console.log("Email response", response);

      if (response.status >= 200 && response.status < 300) {
        if (!response.data || response.data?.result === "Success") {
          toast.success("Email sent successfully!!");
        } else {
          toast.error("Failed to send Email.");
        }
      } else {
        toast.error(`Email failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error("An error occurred while sending the email.");
    }
  };

  // Added by Gauri for showing stage approvers details on 29 Apr 2025
  useEffect(() => {
    if (!initiativesID) return; // Guard clause - Added by Gauri on 04 Nov 2025
    
    const fetchStageDetails = async () => {
      try {
        const result = await GetInitiativeStageDetails(initiativesID);
        console.log("GetInitiativeStageDetails API result:", result);
  
        const stageApprovalList = result?.data?.initiativeStageDetailsEntity?.[0]?.initiativeStageApprovalDetailsEntity || [];
  
        const currentStage = stageApprovalList.find(stage => stage.isCurrentStage === 1);
  
        console.log("Forcepush currentStage details:", currentStage);
  
        if (currentStage) {
          setStageDetails(currentStage);
        }
      } catch (error) {
        console.error("Error fetching initiative stage details:", error);
      }
    }
  
    fetchStageDetails();
  }, [initiativesID, refreshKey]); // Added refreshKey by Gauri to refresh data when WorkflowApprovers is saved on 04 Nov 2025

  // const approvers = stageDetails.approverList.split(", ");
  const approvers = stageDetails?.approverList ? stageDetails.approverList.split(", ") : [];
  console.log("Forcepush approvers details", approvers);
  {/* End of Added by Gauri for showing stage approvers details on 26 Mar 2025 */}

  console.log("ApprovedBy raw value:", stageDetails?.approvedBy);

  // const approvedByList = stageDetails?.approvedBy
  // ? stageDetails.approvedBy.split(",").map(s => s.trim())
  // : [];

  const approvedByList = stageDetails?.approvedBy
  ? stageDetails.approvedBy.split(",").map(s => s.split(" (")[0].trim())
  : [];


  // const approverNamesOnly = approvers.map(name => name.split(" (")[0].trim());

  // const pendingApprovers = approverNamesOnly.filter(
  //   name => !approvedByList.includes(name)
  // );
  const approverNamesOnly = approvers.map(name => name.split(" (")[0].trim());

  const pendingApprovers = approverNamesOnly.filter(
    name => !approvedByList.includes(name)
  );

  // console.log("Forcepush pendingApprovers:", pendingApprovers);

  // console.log("Forcepush approvedByList:", approvedByList);
  // console.log("Forcepush approvedByList:", approvedByList.includes(approver.split(" (")[0].trim()));

  const isCompletedCurrentStage = data1?.some(
    (stage) => stage.requestStage === "Completed" && stage.isCurrentStage === 1
  );

  // -------------------------------------
  {/* Added by Gauri on 02 May 2025 */}
  const approverDisplayNames = stageDetails?.approverList
  ? stageDetails.approverList.split(",").map(s => s.trim())
  : [];
  console.log("approverDisplayNames", approverDisplayNames)

  const approverUserNames = stageDetails?.approverUserList
    ? stageDetails.approverUserList.split(",").map(s => s.trim())
    : [];
  console.log("approverUserNames", approverUserNames)

  const baseDisplayNames = approverDisplayNames.map(name => name.split(" (")[0].trim());
  console.log("baseDisplayNames", baseDisplayNames)

  const pendingBaseNames = baseDisplayNames.filter(
    name => !approvedByList.includes(name)
  );
  console.log("pendingBaseNames", pendingBaseNames)

  const pendingUsernames = pendingBaseNames.map(name => {
    const index = baseDisplayNames.findIndex(display => display === name);
    return approverUserNames[index] || name;
  });
  console.log("pendingUsernames", pendingUsernames)

  return (
    <div style={{ padding: "20px", backgroundColor: "#f9f9f9" }}>
      <Typography variant="subtitle1" sx={{ marginBottom: "20px", fontWeight: "bold" }}>
        3. Force push
      </Typography>
      <div className="row">
        {/* Added condition by Gauri to hide section for Draft initiative on 31 Mar 2025 */}
        {!isCompletedCurrentStage && iniAlertType !== "Draft" && iniAlertType !== undefined && (
          <>
            <div className="col-sm-12">
              <div className="col-sm-12">
                {/* Added by Gauri for showing current stage on 26 Mar 2025 */}
                {/* <span>Approvers for the stage <strong>'{stageDetails?.requestStage}'</strong></span> */}
                <span>Approvers for the stage <strong>'{stageDetails?.fromStage}'</strong></span>
              </div>
            </div>

            <div className="details-main-sec">
              <div className="d-sec1 px-4">
                <table className="table details-table1 mb-0 w-50">
                  <thead>
                    <tr>
                      <th>Approver</th>
                      <th className="tital22">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {approvers.map((approver, index) => ( */}
                    {pendingUsernames.map((username, index) => (
                      <tr>
                        {/* <td>{approver}</td> */}
                        <td>{username}</td>
                        <td className="tital22">
                          {/* {stageDetails.isStageApproved === 0 ? "Not Approved" : "Approved"} */}
                          {/* {approvedByList.includes(approver.trim()) ? "Approved" : "Not Approved"} */}
                          {/* {approvedByList.includes(approver.split(" (")[0].trim()) ? "Approved" : "Not Approved"} */}
                          {approvedByList.includes(username.split(" (")[0].trim()) ? "Approved" : "Not Approved"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {isCompletedCurrentStage ? (
          <span className="tital11 pt-2">
            {/* Passed data by Gauri for Force push workflow on 20 Mar 2025 */}
            Force push <strong>'{data?.title}'</strong> is not applicable as initiative is in Roadmap Stage.
          </span>
        ) : iniAlertType === "ToDoList" ? (
          <span className="tital11 pt-2">
            {/* Passed data by Gauri for Force push workflow on 20 Mar 2025 */}
            {/* You can force push <strong>'{data?.title}'</strong> to next approval stage as <strong>'{stageDetails?.approverList}'</strong> has not approved */}
            {/* You can force push <strong>'{data?.title}'</strong> to next approval stage as <strong>'{pendingApprovers.join(", ")}'</strong> has not approved */}
            You can force push <strong>'{data?.title}'</strong> to next approval stage as <strong>'{pendingUsernames.join(", ")}'</strong> has not approved
            the initiative. &nbsp;
            <a
              href="javascript:;"
              onClick={() => setModalOpen(true)}
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: "bold",
                color: "blue",
              }}
            >
              Click here
            </a>&nbsp;
            to move initiative to next stage.
          </span>
        ) : 
        iniAlertType === "WatchList" ? (
          <span className="tital11 pt-2">
            {/* You can force push <strong>'{data?.title}'</strong> to next approval stage as <strong>'{stageDetails?.approverList}'</strong> has not approved the initiative.  */}
            {/* You can force push <strong>'{data?.title}'</strong> to next approval stage as <strong>'{pendingApprovers.join(", ")}'</strong> has not approved the initiative.  */}
            You can force push <strong>'{data?.title}'</strong> to next approval stage as <strong>'{pendingUsernames.join(", ")}'</strong> has not approved the initiative. 
            &nbsp;
            <a
              href="javascript:;"
              onClick={() => setModalOpen(true)}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              Click here
            </a>&nbsp; to move initiative to next stage.
          </span>
        ) :
        iniAlertType === "Draft" || iniAlertType === undefined ? (
          <span className="tital11 pt-2">
            {/* Passed data by Gauri for Force push workflow on 20 Mar 2025 */}
            You can not force push <strong>'{data?.title}'</strong> initiative to next approval stage as initiative needs to be submitted.
          </span>
        ) : null}        
      </div>

      <Dialog
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="confirmation-dialog-title"
      >
        <DialogTitle id="confirmation-dialog-title">Confirm Force Push</DialogTitle>
        <DialogContent>This Action will forcefully move the Initiative to Next Stage, <br/>
          Click OK if you want to force push the initiative else click Cancel.
        </DialogContent>
        <DialogActions>
          <PrimaryButton text="Ok" onClick={handleConfirmPushBack} />
          <PrimaryButton text="Cancel" onClick={handleModalClose} />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default WorkflowForcePush;
